import { render, staticRenderFns } from "./AdminEventVolunteers.vue?vue&type=template&id=78c4be58&scoped=true&"
import script from "./AdminEventVolunteers.vue?vue&type=script&lang=js&"
export * from "./AdminEventVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4be58",
  null
  
)

export default component.exports